var $0030f210b040e540$exports = {};
$0030f210b040e540$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{5D1}\u{5D7}\u{5E8} \u{5E4}\u{5E8}\u{5D9}\u{5D8}`,
    "tableResizer": `\u{5E9}\u{5D9}\u{5E0}\u{5D5}\u{5D9} \u{5D2}\u{5D5}\u{5D3}\u{5DC}`
};


export {$0030f210b040e540$exports as default};
//# sourceMappingURL=he-IL.module.js.map
